export default __webpack_public_path__ + "static/media/github.1e7198f4.png";